/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {RadioItem} from './radio-item';
import {IEntity} from '../../interface/IEntity';

/**
 * @deprecated
 */
export class RadioGroup implements IEntity {
  id: string;
  label: string;
  items: RadioItem[] = [];
  public lock: boolean;

  constructor(id?: string, label?: string) {
    this.id = id;
    this.label = label;
  }

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return this.label;
  }

  getFirstItem() {
    return this.items[0];
  }

  public serialize(): any {
    return {
      'id': this.id,
      label: this.label,
      items: this.items.map(it => it.serialize())
    };
  }
}
